import Container from '@/container';
import {Col, Grid, Row} from '@/grid';
import {withMarginBottom2xl, withMarginBottomMd, withMarginBottomSm} from '@/hocs/withSpacing';
import Link from '@/links';
import {SectionPadding} from '@/section';
import {H2, H3, PMarginSm, PNoMargin} from '@/typography';
import {GridItem, GridLayout} from '@/ui/grid/grid-layout';
import {ListTerms} from '@/ui/lists/list-icons';
import partnersStyles from 'pages/partnership-program/partners.module.scss';

const H3marginedSm = withMarginBottomSm(H3);
const DivMargined2xl = withMarginBottom2xl('div');
const DivMarginedMd = withMarginBottomMd('div');
const findPartnersArray = [
  {
    title: <>Technology partners</>,
    content: [
      'Collaborate with the market leader in hiring and HR technology.',
      'Work with our team to build product integrations at any stage of the hiring or HR process.'
    ],
    list: ['Provide a seamless customers experience', 'Tap into new clients', 'Earn rewards'],
    url: 'technology-partners'
  },
  {
    title: 'Channel partners',
    content: [
      'Become a trusted Channel Partner and grow your business with access to leading technology.',
      'Collaborate with us to unlock new revenue and connect with high-performing teams.'
    ],
    list: ['Expand market reach', 'Increased brand visibility', 'Scalable referral growth'],
    url: 'channel-partners'
  }
];

const FindPartnersSection = () => (
  <div className={partnersStyles['image-overlay']}>
    <img
      className={partnersStyles['bg-img']}
      loading="lazy"
      src="/static/images/partnership-program/main-page/find-partners/partnership-business-program.jpg"
      alt="Background image with vertical linear gradient having shades of light green, white and red"
    />
    <SectionPadding id="find-the-right-partnership" className={partnersStyles.content}>
      <Container>
        <Grid fluid>
          <DivMargined2xl>
            <Row center="xs">
              <Col xs={12} lg={7}>
                <H2>Find the right partnership for your business</H2>
              </Col>
            </Row>
          </DivMargined2xl>
          <Row>
            <Col xs={12}>
              <GridLayout Col={2} lgCol={1} autoRows>
                {findPartnersArray.map((partner, index) => (
                  <GridItem key={index}>
                    <div className={partnersStyles['partner-box']}>
                      <H3marginedSm>{partner.title}</H3marginedSm>
                      {partner.content.map((paragraph, pIndex) => (
                        <PMarginSm key={pIndex}>{paragraph}</PMarginSm>
                      ))}
                      <DivMarginedMd>
                        <ListTerms>
                          {partner.list.map((listItem, lIndex) => (
                            <li key={lIndex}>{listItem}</li>
                          ))}
                        </ListTerms>
                      </DivMarginedMd>
                      <div className={partnersStyles['link-wrapper']}>
                        <Link href={`/partnership-program/${partner.url}`} variant="cta-default-xs">
                          Find out more
                        </Link>
                        <PNoMargin>or</PNoMargin>
                        <Link href="/partnership-program/apply" variant="primary-sm">
                          Partner with us
                        </Link>
                      </div>
                    </div>
                  </GridItem>
                ))}
              </GridLayout>
            </Col>
          </Row>
        </Grid>
      </Container>
    </SectionPadding>
  </div>
);

export default FindPartnersSection;
